import { InvoiceGenerationOptionEnum } from '~modules/connectors/constants/Invoice-generation.option';
import { InvoiceAmountDifferenceOptionEnum } from '~modules/connectors/constants/invoice-amount-difference.option';
import { AccountingEntriesFieldsConfiguration, DescriptionOption } from '~modules/connectors/services/extract-connectors-configurations/field-type';
import { clientThirdPartTemplatingNameFieldOption, clientThirdPartyTemplatingOptions, defaultEntryDescriptionEmptyFieldOption, defaultGroupingDescriptionEmptyFieldOption, getSellInvoiceEntryDescriptionFieldOptions, getSellInvoiceEntryLineDescriptionFieldOptions, getSellInvoiceGroupingDescriptionFieldOptions, sellInvoiceEntryLineDescriptionThirdPartFieldOption } from './default-transformation-fields';
import { DocumentRefOptionEnum, getDocumentRefOptions } from '~modules/connectors/constants/document-ref.option';

const sellInvoiceGroupingDescriptionOptions: DescriptionOption[] = getSellInvoiceGroupingDescriptionFieldOptions();

const sellInvoiceEntryDescriptionOptions: DescriptionOption[] = getSellInvoiceEntryDescriptionFieldOptions({
    withThirdPart: true
});

const sellInvoiceEntryLineDescriptionOptions: DescriptionOption[] = getSellInvoiceEntryLineDescriptionFieldOptions({
    withThirdPart: true
});

export const qontoRegateTransformationFieldsConfiguration: AccountingEntriesFieldsConfiguration = {
    toolLabel: 'Qonto Regate',

    sellInvoiceProcessorConfiguration: {
        journal: {
            code: {
                defaultValue: 'VT'
            },
            label: {
                defaultValue: 'Ventes'
            }
        },
        thirdPartyAccount: {
            useSuggestedAccounts: {
                visible: false,
                defaultValue: false
            },
            account: {
                defaultValue: '411'
            },
            label: {
                defaultValue: 'Clients'
            },
            isDynamic: {
                defaultValue: true
            },
            auxiliaryLabelStatic: {
                defaultValue: 'CLIENTS'
            },
            auxiliaryAccountStatic: {
                defaultValue: 'CLIENTS'
            },
            auxiliaryDynamic: {
                options: clientThirdPartyTemplatingOptions,
                defaultOption: clientThirdPartTemplatingNameFieldOption
            }
        },
        generation: {
            useSuggestedProductsAccounts: {
                visible: false,
                defaultValue: false
            },
            option: {
                defaultWithSuggestedAccountValue: null,
                defaultWithoutSuggestedAccountValue: InvoiceGenerationOptionEnum.ONE_LINE_PER_VAT_RATE
            },
            oneLinePerVatRate: {
                productVats: {
                    columns: {
                        countryCode: {
                            visible: false,
                            canEdit: false
                        },
                        regime: {
                            visible: false,
                            canEdit: false
                        }
                    },
                    defaultAccount: {
                        countryCode: null,
                        regime: null,
                        rate: null,
                        account: '706099',
                        accountLabel: 'Produits à reclasser'
                    },
                    accounts: [
                        {
                            countryCode: null,
                            regime: null,
                            rate: 0,
                            account: '706000',
                            accountLabel: 'Ventes TVA 0%'
                        },
                        {
                            countryCode: null,
                            regime: null,
                            rate: 5.5,
                            account: '706055',
                            accountLabel: 'Ventes TVA 5,5%'
                        },
                        {
                            countryCode: null,
                            regime: null,
                            rate: 10,
                            account: '706010',
                            accountLabel: 'Ventes TVA 10%'
                        },
                        {
                            countryCode: null,
                            regime: null,
                            rate: 20,
                            account: '706020',
                            accountLabel: 'Ventes TVA 20%'
                        }
                    ]
                }
            },
            oneLinePerInvoiceLine: {
                productVats: {
                    columns: {
                        countryCode: {
                            visible: false,
                            canEdit: false
                        },
                        regime: {
                            visible: false,
                            canEdit: false
                        }
                    },
                    defaultAccount: {
                        countryCode: null,
                        regime: null,
                        rate: null,
                        account: '706099',
                        accountLabel: 'Produits à reclasser'
                    },
                    accounts: [
                        {
                            countryCode: null,
                            regime: null,
                            rate: 0,
                            account: '706000',
                            accountLabel: 'Ventes TVA 0%'
                        },
                        {
                            countryCode: null,
                            regime: null,
                            rate: 5.5,
                            account: '706055',
                            accountLabel: 'Ventes TVA 5,5%'
                        },
                        {
                            countryCode: null,
                            regime: null,
                            rate: 10,
                            account: '706010',
                            accountLabel: 'Ventes TVA 10%'
                        },
                        {
                            countryCode: null,
                            regime: null,
                            rate: 20,
                            account: '706020',
                            accountLabel: 'Ventes TVA 20%'
                        }
                    ]
                }
            },
            oneGlobalLine: {
                product: {
                    account: {
                        defaultValue: '706000'
                    },
                    label: {
                        defaultValue: 'Produit'
                    }
                }
            }
        },
        useSuggestedVatsAccounts: {
                visible: false,
                defaultValue: false
        },
        collectedVats: {
            columns: {
                countryCode: {
                    visible: false,
                    canEdit: false
                },
                regime: {
                    visible: false,
                    canEdit: false
                }
            },
            defaultAccount: {
                countryCode: null,
                regime: null,
                rate: null,
                account: '44571099',
                accountLabel: 'TVA à reclasser'
            },
            accounts: [
                {
                    countryCode: null,
                    regime: null,
                    rate: 5.5,
                    account: '44571055',
                    accountLabel: 'TVA collectée 5,5%'
                },
                {
                    countryCode: null,
                    regime: null,
                    rate: 10,
                    account: '44571010',
                    accountLabel: 'TVA collectée 10%'
                },
                {
                    countryCode: null,
                    regime: null,
                    rate: 20,
                    account: '44571020',
                    accountLabel: 'TVA collectée 20%'
                }
            ]
        },
        amountDifferenceOption: {
            defaultValue: InvoiceAmountDifferenceOptionEnum.ADJUST_HT
        },
        debitAdjustment: {
            account: {
                defaultValue: "658"
            },
            label: {
                defaultValue: "Charges diverses de gestion courante"
            }
        },
        creditAdjustment: {
            account: {
                defaultValue: "758"
            },
            label: {
                defaultValue: "Produits divers de gestion courante"
            }
        },
        documentRef: {
            visible: false,
            options: getDocumentRefOptions(),
            defaultValue: DocumentRefOptionEnum.INVOICE_FUNCTIONAL_ID
        },
        groupingDescription: {
            visible: false,
            options: sellInvoiceGroupingDescriptionOptions,
            defaultOption: defaultGroupingDescriptionEmptyFieldOption
        },
        entryDescription: {
            options: sellInvoiceEntryDescriptionOptions,
            defaultOption: defaultEntryDescriptionEmptyFieldOption
        },
        entryLineDescription: {
            options: sellInvoiceEntryLineDescriptionOptions,
            defaultOption: sellInvoiceEntryLineDescriptionThirdPartFieldOption
        }
    },

    analyticProcessorConfiguration: {
        isEnabled: {
            defaultValue: false
        },
        accountRules: {}
    }
}